import { styled } from 'styled-components';

import { breakpointTablet } from 'src/styles/breakpoints';
import { colorBorder, colorNeutral } from 'src/styles/colors';
import { spacing2, spacing3, spacing5 } from 'src/styles/spacing';

export const StyledCard = styled.div`
  border: 1px solid ${colorBorder};
  box-sizing: border-box;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  border-radius: 2px;
  padding: ${spacing3} ${spacing2};
  max-width: 364px;
  background-color: ${colorNeutral};

  @media (min-width: ${breakpointTablet}) {
    min-width: 358px;
    padding: ${spacing5} ${spacing3};
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;
